import React, { Component } from 'react';
import TableViewer from './TableViewer';
import HttpServices from '../utils/Http.services';

class TableReportAll extends Component {
    state = {
        headers: [
            { key: 'name', type: 'TextInput', information: { label: '{{lang}}Name' }, inplaceEditable: false },
            { key: 'invoice balance fcy', type: 'TextInput', information: { label: '{{lang}}Opennig time' } },
            { key: 'available credits fcy', type: 'TextInput', information: { label: '{{lang}}Closing time' } },
            { key: 'balance fcy', type: 'TextInput', information: { label: '{{lang}}Points' } },
            { key: 'BALANCE bcy', type: 'TextInput', information: { label: '{{lang}}Results' } },
        ],
        members: [
            { step: '0', name: 'Parna Azizi' },
            { step: '1', name: 'Nastaran Javid' },
            { step: '2', name: 'Hossein mohseni' },
            { step: '3', name: 'Pedram Pezhman' },
        ]
    }
    componentDidMount() {
        // HttpServices.request('getRecord', {  }, (fetchResult, fetchError) => {
        //     if (fetchError) {
        //         return
        //     }
            
        // })
    }
    render() {
        return (
            <div className="bg-white">
                <div className="w-100 shadow-2 br-10" style={{ overflow: 'hidden' }}>
                    <div className="w-100">
                        <TableViewer
                            headers={this.props.headers}
                            data={this.props.data}
                            // actions={this.state.actions}
                            ref={el => this.TableViewer = el}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export default TableReportAll;